module.exports = __webpack_public_path__ + "img/info-btn.b53f59e8.png";